import { useSearchParams } from 'next/navigation';
import { memo } from 'react';
import OfferSchema from './OfferSchema';
import { Entry } from 'contentful';
import { ExtendedProductFields } from '@/core/contentfulConfig';

export interface ProductSchemaProps {
  product: Entry<ExtendedProductFields>;
  url?: string; // Required when appearing outside of a product page
}

function buildProductUrl({ slug = '', variant = '' }) {
  const variantQuery = variant ? `?variant=${variant}` : '';
  return `https://${process.env.NEXT_PUBLIC_VANITY_DOMAIN}/products/${slug}${variantQuery}`;
}

const ProductSchema = ({ product, url }: ProductSchemaProps) => {
  const searchParams = useSearchParams();
  const imageUrl = product.fields.featuredImage?.fields.Image?.fields.file?.url;
  const productUrl =
    url ||
    buildProductUrl({
      slug: searchParams?.get('slug') || '',
      variant: searchParams?.get('variant') || '',
    });
  const variant = product.fields.shopifyProduct?.variants[0];

  return (
    <div>
      <meta itemProp="name" content={product.fields.title} />
      <meta itemProp="url" content={productUrl} />
      <meta itemProp="brand" content="Lovevery" />
      <meta itemProp="image" content={imageUrl} />
      <meta itemProp="description" content={product.fields.shortDescription} />
      {variant && (
        <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
          <OfferSchema variant={variant} url={productUrl} />
        </div>
      )}
    </div>
  );
};

export default memo(ProductSchema);
